<template>
  <j-modal
    :title="title"
    :visible="visible"
    :destroyOnClose="true"
    :centered="true"
    :dialogClass="dialogClass"
    :width="width"
    :size="size"
    @cancel="handleCancel(true)"
  >
    <template slot="footer">
      <!-- 履歴 -->
      <a-button
        v-if="procInstId && !isUnReal"
        class="ant-btn-history"
        @click="$refs.TrackModal.open(procInstId, title)"
      >
        <span class="mdi mdi-transit-connection-variant" style="color: var(--color-primary)"></span>
        履历
      </a-button>

      <!-- 打印 -->
      <a-button v-if="showPrint" @click="$refs.applyComponent.handlePrint" icon="printer" type="primary">
        <!--<span class="mdi mdi-transit-connection-variant" style="color: var(--color-primary)"></span>-->
        打印
      </a-button>

      <!-- 申請者向けのボタン -->
      <!-- 申請ポータルから popupFrom: '1' -->
      <!-- 一時保存一覧から popupFrom: '2' -->
      <div class="div-apply" v-if="popupFrom == '1' || popupFrom == '2'">
        <!-- プレビュー -->
        <a-button class="a-button-force-show" type="primary" icon="file-pdf" v-if="previewFlag" @click="doPreview">{{
          $t('disp.preview')
        }}</a-button>

        <!-- 再利用 -->
        <a-button type="primary" icon="select" v-if="showReuse" @click="openReuse">{{ $t('disp.btn.reuse') }}</a-button>
        <!-- 一時保存 -->
        <a-button type="primary" icon="check" @click="doSave" :disabled="disableSave">保存</a-button>

        <!-- 申請 -->
        <a-button type="primary" icon="arrow-right" :disabled="disableApply" @click="doApply"
          >{{ $t('disp.flow.apply') }}
        </a-button>
      </div>

      <!-- 承認者向けのボタン -->
      <!-- 未処理一覧から popupFrom: '3' -->
      <div class="div-apply" v-else-if="popupFrom == '3'">
        <!-- 再申請の場合 -->
        <div v-if="status == 'disp.flow.applyWait'">
          <!-- プレビュー -->
          <a-button
            ghost
            class="a-button-force-show"
            type="primary"
            icon="file-pdf"
            v-if="previewFlag"
            @click="doPreview"
            >{{ $t('disp.preview') }}
          </a-button>

          <!-- 再申請 -->
          <a-button type="primary" icon="arrow-right" :disabled="disableApplyAgain" @click="doApply">{{
            $t('disp.flow.applyAgain')
          }}</a-button>
        </div>

        <!-- 承認待ちの場合 -->
        <div v-if="status == 'disp.flow.approveWait'">
          <!-- 差戻対象ノード -->
          <!--<a-select v-model="turnbackTaskDefinitionKey" style="min-width: 160px; width: auto" :allowClear="false">
            <a-select-option
              v-for="item in turnbackTargets"
              :key="item.taskDefinitionKey"
              :value="item.taskDefinitionKey"
              :title="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>-->

          <!-- 委派 -->
          <a-button type="primary" icon="user-add" @click="handleAppoint()">委派</a-button>

          <!-- 差戻 -->
          <a-button type="primary" icon="arrow-left" @click="doTurnback">{{ $t('disp.flow.turnback') }}</a-button>

          <!-- 却下 -->
          <a-button type="primary" icon="close" @click="doRefuse">{{ $t('disp.flow.refuse') }}</a-button>

          <!-- 承認 -->
          <a-button type="primary" icon="check" :disabled="disableConfirm" @click="doConfirm">{{
            $t('disp.flow.confirm')
          }}</a-button>
        </div>
      </div>

      <!-- 参照モード -->
      <!-- 処理済一覧・進行中案件 or 申請案件一覧・進行中案件から popupFrom: '4' -->
      <!-- 処理済一覧・終了案件 or 申請案件一覧・終了案件から popupFrom: '5' -->
      <!-- 処理済一覧・終了案件 or 申請案件一覧・終了案件から popupFrom: '6' -->
      <!-- 検索一覧画面などのリンクから popupFrom: '0' -->
      <div class="div-apply" v-else>
        <!-- 帳票出力 -->
        <!-- 最終承認済みの場合のみ表示 -->
        <a-button v-if="publishFlag && status == 'disp.flow.end'" type="primary" icon="file-pdf" @click="doPublish"
          >打印账票</a-button
        >

        <!-- 批量下载 -->
        <a-button
          v-if="batchDownLoadFlag && status == 'disp.flow.end'"
          type="primary"
          icon="download"
          @click="doBatchDownLoad"
          >批量下载</a-button
        >

        <!-- 编辑确定 -->
        <a-button v-if="forceEdit || serviceConfirmEdit" type="primary" icon="check" @click="doEdit">确定</a-button>

        <!-- 閉じる -->
        <a-button
          v-if="!((publishFlag && status == 'disp.flow.end') || forceEdit)"
          type="primary"
          @click="handleCancel"
          icon="close"
          >{{ $t('disp.btn.close') }}</a-button
        >
      </div>
    </template>

    <div
      v-if="showPrint"
      class="flow-title"
      style="
        justify-content: center;
        font-size: 20px;
        display: none;
        border-bottom: 3px solid #eee;
        width: fit-content;
        margin: auto;
        padding: 0 10px;
        position: relative;
        top: -20px;
      "
    >
      {{ printTitle }}
    </div>

    <component ref="applyComponent" class="a-modal-applyForm" v-bind:is="src" :_p="this">
      <!-- 申請者情報 -->
      <template v-slot:applicantInfo>
        <span class="anchor-applicantInfo" v-if="!isUnReal"></span>
      </template>

      <!-- 申请原因 or 审批意见 -->
      <template v-slot:applyComment v-if="!isUnReal">
        <a-descriptions
          class="comment-wrapper"
          :column="forceColumn || column"
          v-if="popupFrom == '1' || popupFrom == '2' || popupFrom == '3' || commentList.length > 0"
        >
          <template slot="title">
            <span>申请原因</span>
            <j-slash></j-slash>
            <span>审批意见</span>
          </template>

          <a-descriptions-item span="2" v-if="popupFrom == '1' || popupFrom == '2' || popupFrom == '3'">
            <template slot="label">
              <span>详细内容</span>
            </template>
            <a-form-model-item>
              <div class="div-apply-comment">
                <a-textarea
                  @keyup.enter.stop
                  placeholder="需要补充说明的时候请填写"
                  v-model="comment"
                  :maxLength="900"
                  :autoSize="{
                    minRows: 3,
                  }"
                />
              </div>
            </a-form-model-item>
          </a-descriptions-item>
        </a-descriptions>

        <HistoryOperation
          :onlyComment="true"
          style="padding-left: 6px"
          :style="{
            display: commentList.length > 0 ? 'block' : 'none',
            paddingTop: popupFrom == '1' || popupFrom == '2' || popupFrom == '3' ? '15px' : '10px',
          }"
          :processInstanceId="procInstId"
          v-if="procInstId"
          @emit="emitFromHistoryOperation"
        ></HistoryOperation>
      </template>
    </component>

    <a-descriptions
      class="flow-confirm-list no-label"
      v-if="showPrint && confirmOperations.length > 0"
      style="display: none"
    >
      <template slot="title">审批信息列表</template>
      <a-descriptions-item>
        <a-table rowKey="createTime" tableLayout="auto" bordered :pagination="false" :dataSource="confirmOperations">
          <a-table-column key="index" title="#" :width="47" align="center">
            <template slot-scope="text, record, index">
              {{ parseInt(index) + 1 }}
            </template>
          </a-table-column>

          <a-table-column key="createTime" data-index="createTime">
            <span slot="title">审批时间</span>
            <template slot-scope="text, record">{{ moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') }}</template>
          </a-table-column>

          <a-table-column key="actionRealname" data-index="actionRealname">
            <span slot="title">审批人</span>
            <template slot-scope="text, record">
              <span>{{ record.actionRealname }}</span>
            </template>
          </a-table-column>

          <a-table-column key="taskName" data-index="taskName">
            <span slot="title">审批节点</span>
            <template slot-scope="text, record">
              <span>{{ record.taskName }}</span>
            </template>
          </a-table-column>

          <a-table-column key="action" data-index="action">
            <span slot="title">审批结果</span>
            <template slot-scope="text, record">
              <span v-if="record.actionRealname.indexOf(';') < 0">{{ $t(record.action) }}</span>
              <span v-else>{{ ' 代理' + record.actionRealname.split(';')[1] + $t(record.action) }}</span>

              <span v-if="record.backwardTaskName">{{ '至 ' }}</span>

              <span style="letter-spacing: 1px; color: var(--color-grey)" v-if="record.backwardTaskName">{{
                '＠' + record.backwardTaskName
              }}</span>
            </template>
          </a-table-column>

          <a-table-column key="comment" data-index="comment">
            <span slot="title">审批意见</span>
            <template slot-scope="text, record">
              <span v-if="record.comment">{{ record.comment }}</span>
              <JEmpty v-else></JEmpty>
            </template>
          </a-table-column>
        </a-table>
      </a-descriptions-item>
    </a-descriptions>

    <!-- 委派 -->
    <AppointModal ref="AppointModal" @emit="handleCancel()"></AppointModal>

    <!-- 履历 -->
    <TrackModal ref="TrackModal"></TrackModal>

    <!-- 再利用 -->
    <reuse-modal ref="ReuseModal" @emit="doReuse"></reuse-modal>

    <j-modal
      title="驳回"
      :visible="visibleTurnback"
      :destroyOnClose="true"
      :centered="true"
      :width="940"
      @ok="handleTurnbackOk()"
      @cancel="visibleTurnback = false"
    >
      <div style="font-size: 15px; margin-top: -6px; margin-bottom: 3px; color: black">
        <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
        <span>请选择驳回节点：</span>
      </div>

      <div class="div-flow-filter">
        <a-popover v-for="item in turnbackTargets" :key="item.taskDefinitionKey" placement="topLeft">
          <div slot="content" v-if="XEUtils.filter(historyOperations, (r) => r.taskName == item.name).length > 0">
            <div>
              {{
                XEUtils.last(XEUtils.filter(historyOperations, (r) => r.taskName == item.name)).actionRealname.split(
                  ';'
                )[0]
              }}
            </div>
            <div class="extraNote">
              {{
                moment(
                  XEUtils.last(XEUtils.filter(historyOperations, (r) => r.taskName == item.name)).createTime
                ).format('YYYY-MM-DD')
              }}
            </div>
          </div>

          <div
            class="turnbackTarget"
            :class="turnbackTaskDefinitionKey == item.taskDefinitionKey ? 'active' : ''"
            @click="turnbackTaskDefinitionKey = item.taskDefinitionKey"
          >
            <span>{{ item.name.replaceAll(' ', '') }}</span>
          </div>
        </a-popover>
      </div>

      <div style="font-size: 15px; margin-top: 13px; margin-bottom: 3px; color: black">
        <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
        <span>请填写驳回原因、修改意见等：</span>
      </div>
      <a-textarea
        @keyup.enter.stop
        placeholder="请尽量阐明驳回原因，以便被驳回节点的处理人做出正确修改"
        v-model="turnbackComment"
        :maxLength="900"
        :autoSize="{
          minRows: 3,
        }"
      />

      <div class="track-wrapper graph" style="height: unset; min-height: 241px; max-height: calc(100vh - 345px)">
        <img :src="trackSrc" style="padding-bottom: 30px" />
      </div>
    </j-modal>
  </j-modal>
</template>

<script>
import { getAction, postAction, putAction } from '@/api/manage'
import { Empty } from 'ant-design-vue'
import ReuseModal from './ReuseModal'
import TrackModal from '@/views/k00/k0011/modules/TrackModal'
import HistoryOperation from '@/views/k00/k0011/modules/HistoryOperation'
import AppointModal from '@/views/k00/k0011/modules/AppointModal'

export default {
  name: 'ApplyModal',
  components: {
    ReuseModal,
    TrackModal,
    HistoryOperation,
    AppointModal,
  },
  data() {
    return {
      visible: false,
      visibleTurnback: false,
      showPrint: false,
      printTitle: undefined,
      editModeForComputed: undefined,
      turnbackComment: undefined,

      // 弹窗size
      width: null,
      size: 'smaller',
      column: 1,
      forceColumn: undefined,

      // 子组件
      src: '',
      component: '',

      // 是否虚拟流程
      isUnReal: false,
      // 模型定义id
      modelId: '',
      // 部署id
      deploymentId: '',
      // フローインスタンスid
      procInstId: '',
      // 任務id
      taskId: '',
      // executionId
      executionId: '',
      // ワークフロー状態
      status: '',
      // 流程初始业务数据
      flowInitData: undefined,
      // 流程外部参数(例如./k05/k0501/DepartBudgetApply?isPersonal=true,则flowComponentParameter会赋值为{isPersonal: 'true'})
      flowComponentParameter: undefined,

      // 从哪个页面弹出(根据前页面不同采用不同的页面控制)
      // 0 下记以外
      // 1 流程首页
      // 2 临时保存流程
      // 3 等待处理流程
      // 4 已处理流程・进行中流程 or 流程总览・进行中流程
      // 5 已处理流程・终了流程 or 流程总览・终了流程
      // 6 流程总览・非活性流程
      popupFrom: '0',
      // 事務系画面から飛んできた場合はtrue
      isHrPage: false,
      // 强制编辑
      forceEdit: false,

      // 服务确认书原件编辑
      serviceConfirmEdit: false,

      // プレビューflag
      previewFlag: false,
      // 帳票出力flag
      publishFlag: false,
      // 批量下载flag
      batchDownLoadFlag: false,
      // trueの場合、承認ボタンを非活性にする
      disableConfirm: false,
      // trueの場合、申請ボタンを非活性にする
      disableApply: false,
      // trueの場合、再申請ボタンを非活性にする
      disableApplyAgain: false,
      // trueの場合、一時保存ボタンを非活性にする
      disableSave: false,
      // 再利用ボタン表示flg
      showReuse: false,

      // 当前login用户
      loginUser: this.$getLoginUser(),
      // 申請者情報
      applicantInfo: {},
      // 歴史承認ノード（リターン用）
      turnbackTargets: [],
      // 驳回对象节点的定义
      turnbackTaskDefinitionKey: '',
      // コメント
      comment: '',
      // コメントList
      commentList: [],
      historyOperations: [],
      confirmOperations: [],

      url: {
        getMetaInfo: '/flow/getMetaInfo',
        applicantInfo: '/flow/applicantInfo',
        getTurnbackTargets: '/flow/getTurnbackTargets',
        applyComment: 'flow/applyComment',
        confirm: '/flow/task/confirm',
        refuse: '/flow/task/refuse',
        turnback: '/flow/task/turnback',
        taskCheck: '/flow/task/exclusiveCheck',
        getAutoConfirmTask: '/flow/task/getAutoConfirmTask',
        getCanApproveTask: '/flow/task/getCanApproveTask',
      },
    }
  },
  computed: {
    editMode: {
      get: function () {
        if (this.visible && XEUtils.isUndefined(this.editModeForComputed)) {
          this.editModeForComputed =
            this.popupFrom == '1' ||
            this.popupFrom == '2' ||
            (this.popupFrom == '3' && this.status == 'disp.flow.applyWait')
        }

        return this.editModeForComputed
      },
      set: function (newValue) {
        this.editModeForComputed = newValue
      },
    },
    trackSrc() {
      return (
        window._CONFIG['domianURL'] +
        '/flow/processTracking?processInstanceId=' +
        this.procInstId +
        '&locale=' +
        Vue.ls.get('Locale') +
        '&_t=' +
        Date.now()
      )
    },
    //editMode() {
    //  return (
    //    this.popupFrom == '1' ||
    //    this.popupFrom == '2' ||
    //    (this.popupFrom == '3' && this.status == 'disp.flow.applyWait')
    //  )
    //},
  },
  watch: {
    visible: {
      //immediate: true,
      handler() {
        if (this.visible) {
          // JInputPopup link
          if (this.$attrs.params) {
            // 0 下記以外
            // 1 申請ポータル
            // 2 一時保存一覧
            // 3 未処理一覧
            // 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
            // 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
            // 6 処理済一覧・非活性案件
            this.popupFrom = '0'

            this.procInstId = this.$attrs.params.procInstId
            this.status = ''
            this.handleOpen()
          }
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    /*******************************************
     * 打开弹出框
     *******************************************/
    async handleOpen() {
      // 获取申请基本信息
      await this.getApplicantInfo()
      // 获取申请原因 or 审批意见
      //this.getApplyComment()

      if (this.popupFrom == '0') {
        this.title = '详细信息'
      }

      // 已具备meta信息 则直接加载
      if (this.component && this.title) {
        this.loadComponent()
      }
      // 无meta信息 则需要根据procInstId从服务器端获取
      else {
        getAction(this.url.getMetaInfo, { procInstId: this.procInstId }).then((res) => {
          if (res.success) {
            this.component = res.result.component
            this.deploymentId = res.result.deploymentId

            if (this.popupFrom == '0') {
              this.title = '详细信息'
            } else {
              this.title = res.result.title
            }

            this.loadComponent()
          }
        })
      }
    },

    /*******************************************
     * 关闭弹出框
     *******************************************/
    handleCancel(noSearch) {
      document.body.attributes['data-url'] = null
      this.turnbackTaskDefinitionKey = null
      this.visible = false
      this.editModeForComputed = undefined
      this.comment = null
      this.applicantInfo = {}
      this.component = ''
      this.deploymentId = ''
      this.title = ''
      this.popupFrom = '0'
      this.width = null
      this.size = 'smaller'
      this.column = 1
      this.forceColumn = undefined
      this.flowInitData = undefined
      this.flowParameter = undefined
      this.serviceConfirmEdit = undefined

      // 他の申請モーダルに影響しないように、元に戻す
      this.isUnReal = false
      this.taskId = ''
      this.procInstId = ''
      this.disableSave = false
      this.disableConfirm = false
      this.disableApply = false
      this.disableApplyAgain = false
      this.showReuse = false
      this.previewFlag = false
      this.publishFlag = false
      this.batchDownLoadFlag = false
      this.isHrPage = false
      this.showPrint = false

      if (!noSearch) {
        this.$emit('searchQuery')
      }
    },

    /*******************************************
     * 获取申请基本信息
     *******************************************/
    async getApplicantInfo() {
      if (this.isUnReal) {
        return
      }

      // DB中已有数据
      if (this.procInstId) {
        this.applicantInfo.procInstId = this.procInstId
        this.applicantInfo.taskId = this.taskId

        await getAction(this.url.applicantInfo, this.applicantInfo).then((res) => {
          if (res.success) {
            this.applicantInfo = res.result
            if (res.result.applyStatus) {
              this.status = res.result.applyStatus

              var interval = setInterval(() => {
                if (document.querySelector('.anchor-applicantInfo')) {
                  clearInterval(interval)
                  this.createApplicantInfoDom()
                }
              }, 100)

              // 事務系画面から飛んできた場合
              if (this.isHrPage && (this.status == 'disp.flow.applyWait' || this.status == 'disp.flow.approveWait')) {
                postAction(this.url.getCanApproveTask, {
                  procInstId: this.procInstId,
                }).then((res) => {
                  if (res.success) {
                    if (res.result) {
                      this.taskId = res.result.id
                      this.executionId = res.result.executionId

                      // 视为可承认状态
                      this.popupFrom = '3'

                      if (this.status == 'disp.flow.approveWait') {
                        this.getTurnbackTargets()
                      }
                    }
                  }
                })
              }
              // 差し戻し用履歴リスト
              else if (this.popupFrom == '3' && this.status == 'disp.flow.approveWait') {
                this.getTurnbackTargets()
              }
            }
          }
        })
      }
      // DB中尚无数据
      else {
        this.applicantInfo.applyStatus = 'disp.flow.apply'
        this.applicantInfo.taskName = '申请'

        var interval = setInterval(() => {
          if (document.querySelector('.anchor-applicantInfo')) {
            clearInterval(interval)
            this.createApplicantInfoDom()
          }
        }, 100)
      }
    },

    /*******************************************
     * 获取申请原因 or 审批意见
     *******************************************/
    emitFromHistoryOperation(historyOperationsFilter, historyOperations) {
      this.commentList = historyOperationsFilter
      this.historyOperations = historyOperations

      this.confirmOperations = []
      for (let i = this.historyOperations.length - 1; i >= 0; i--) {
        const last = this.historyOperations[i]
        if (
          XEUtils.filter(
            this.confirmOperations,
            (r) => r.actionRealname == last.actionRealname && r.taskName == last.taskName
          ).length == 0 &&
          XEUtils.includes(['disp.flow.confirm', 'disp.flow.refuse', 'disp.flow.cancel'], last.action)
        ) {
          this.confirmOperations.push(last)
        }
      }
      this.confirmOperations = this.confirmOperations.reverse()
    },
    //getApplyComment() {
    //  if (this.procInstId) {
    //    getAction(this.url.applyComment, { procInstId: this.procInstId }).then((res) => {
    //      if (res.success) {
    //        this.commentList = res.result
    //      }
    //    })
    //  }
    //},

    /*******************************************
     * 加载子组件
     *******************************************/
    loadComponent() {
      this.visible = true

      var urlObject = XEUtils.parseUrl(this.component)
      this.flowComponentParameter = urlObject.searchQuery

      this.src = require('@/views/' + this.component.split('?')[0]).default
      document.body.attributes['data-url'] = '/' + this.component.split('?')[0]
      console.info(this.component)
    },

    /*******************************************
     * 动态创建申请基本信息的DOM元素
     *******************************************/
    createApplicantInfoDom() {
      var that = this
      const procInstId = that.applicantInfo.procInstId
      const startDate = that.applicantInfo.startDate

      const starterRealname = that.applicantInfo.starterRelation.realname
      const starterUsername = that.applicantInfo.starterRelation.username
      const starterDepartname = that.applicantInfo.starterRelation.departName
      const starterPositionName = that.applicantInfo.starterRelation.positionName
      const starterPostLevel = that.applicantInfo.starterRelation.postLevel
      const starterBizLineName = that.applicantInfo.starterRelation.bizLineName

      var hasAgent = false
      if (that.applicantInfo.agentRelation) {
        hasAgent = true
        var agentRealname = that.applicantInfo.agentRelation.realname
        var agentUsername = that.applicantInfo.agentRelation.username
        var agentDepartname = that.applicantInfo.agentRelation.departName
        var agentPositionName = that.applicantInfo.agentRelation.positionName
        var agentPostLevel = that.applicantInfo.agentRelation.postLevel
        var agentBizLineName = that.applicantInfo.agentRelation.bizLineName
      }

      //#region 生成申请信息区域
      new Vue({
        el: '.anchor-applicantInfo',
        render: function (h) {
          var procInstIdDom = procInstId ? (
            <a-descriptions-item label={that.$t('disp.flow.applyId')}>
              <span style="margin-right: 10px">{procInstId}</span>
              <span class="anchor-applyStatus"></span>
            </a-descriptions-item>
          ) : (
            <a-descriptions-item label={that.$t('disp.flow.applyId')}>
              <span class="anchor-applyStatus"></span>
            </a-descriptions-item>
          )

          var startDateDom = (
            <a-descriptions-item label={that.$t('disp.flow.startDate')}>
              <span>
                {startDate ? moment(startDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')}
              </span>
              <span class="note" style="letter-spacing: 1px;">
                {startDate ? moment(startDate).format(' HH:mm:ss') : moment(new Date()).format(' HH:mm:ss')}
              </span>
            </a-descriptions-item>
          )

          var starterPositionNameDom = starterPositionName ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{starterPositionName}</span>
            </span>
          ) : (
            <span></span>
          )

          var starterBizLineNameDom = starterBizLineName ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{starterBizLineName}</span>
            </span>
          ) : (
            <span></span>
          )

          var starterPostLevelDom = starterPostLevel ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{starterPostLevel}</span>
            </span>
          ) : (
            <span></span>
          )

          var starterUsernameDom = (
            <a-descriptions-item label={that.$t('disp.flow.starter')}>
              <span>{starterRealname}</span>
              <j-slash></j-slash>
              <span class="note" style="font-size: 13px">
                {starterUsername}
              </span>
            </a-descriptions-item>
          )

          var starterRelationDom = (
            <a-descriptions-item label="所属信息">
              <span>{starterDepartname}</span>
              {starterPositionNameDom}
              {starterBizLineNameDom}
            </a-descriptions-item>
          )

          var agentPositionNameDom = agentPositionName ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{agentPositionName}</span>
            </span>
          ) : (
            <span></span>
          )

          var agentBizLineNameDom = agentBizLineName ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{agentBizLineName}</span>
            </span>
          ) : (
            <span></span>
          )

          var agentPostLevelDom = agentPostLevel ? (
            <span>
              <j-slash></j-slash>
              <span style="color: var(--color-grey)">{agentPostLevel}</span>
            </span>
          ) : (
            <span></span>
          )

          var agentUsernameDom = (
            <a-descriptions-item label={that.$t('disp.flow.agent')}>
              <span>{agentRealname}</span>
              <j-slash></j-slash>
              <span class="note" style="font-size: 13px">
                {agentUsername}
              </span>
            </a-descriptions-item>
          )

          var agentRelationDom = (
            <a-descriptions-item label="代理人所属信息">
              <span>{agentDepartname}</span>
              {agentPositionNameDom}
              {agentBizLineNameDom}
            </a-descriptions-item>
          )

          var column = that.forceColumn || that.column

          if (column == 1) {
            return hasAgent ? (
              <a-descriptions title="流程信息" column={column}>
                {procInstIdDom}
                {startDateDom}
                {starterUsernameDom}
                {starterRelationDom}
                {agentUsernameDom}
                {agentRelationDom}
              </a-descriptions>
            ) : (
              <a-descriptions title="流程信息" column={column}>
                {procInstIdDom}
                {startDateDom}
                {starterUsernameDom}
                {starterRelationDom}
              </a-descriptions>
            )
          }
          if (column == 2) {
            return hasAgent ? (
              <a-descriptions title="流程信息" column={column}>
                {procInstIdDom}
                {startDateDom}
                {starterUsernameDom}
                {agentUsernameDom}
                {starterRelationDom}
                {agentRelationDom}
              </a-descriptions>
            ) : (
              <a-descriptions title="流程信息" column={column}>
                {procInstIdDom}
                {starterUsernameDom}
                {startDateDom}
                {starterRelationDom}
              </a-descriptions>
            )
          }
          if (column == 3) {
            return hasAgent ? (
              <a-descriptions title="流程信息" column={column}>
                {procInstIdDom}
                {starterUsernameDom}
                {agentUsernameDom}
                {startDateDom}
                {starterRelationDom}
                {agentRelationDom}
              </a-descriptions>
            ) : (
              <a-descriptions title="流程信息" column={2} style="width: 66.7%;">
                {procInstIdDom}
                {starterUsernameDom}
                {startDateDom}
                {starterRelationDom}
              </a-descriptions>
            )
          }
          if (column == 4) {
            return hasAgent ? (
              <a-descriptions title="流程信息" column={3} style="width: 75%;">
                {procInstIdDom}
                {starterUsernameDom}
                {agentUsernameDom}
                {startDateDom}
                {starterRelationDom}
                {agentRelationDom}
              </a-descriptions>
            ) : (
              <a-descriptions title="流程信息" column={2} style="width: 50%;">
                {procInstIdDom}
                {starterUsernameDom}
                {startDateDom}
                {starterRelationDom}
              </a-descriptions>
            )
          }
        },
      })
      //#endregion 生成申请信息区域

      //#region 生成申请状态标签
      new Vue({
        el: '.anchor-applyStatus',
        render: function (h) {
          if (!procInstId) {
            return <a-tag color="primary"> 新流程 </a-tag>
          } else if (that.status == 'disp.flow.save' || that.status == 'disp.flow.end') {
            return <a-tag color="green">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.applyWait') {
            return <a-tag color="purple">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.approveWait') {
            return <a-tag color="orange">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.keep') {
            return <a-tag color="cyan">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.freeze') {
            return <a-tag color="blue">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.refuse') {
            return <a-tag color="red">{that.$t(that.status)}</a-tag>
          } else if (that.status == 'disp.flow.cancel') {
            return <a-tag>{that.$t(that.status)}</a-tag>
          }
        },
      })
      //#endregion 生成申请状态标签
    },

    /*******************************************
     * 获取历史节点(驳回用)
     *******************************************/
    getTurnbackTargets() {
      if (this.taskId) {
        getAction(this.url.getTurnbackTargets, { taskId: this.taskId }).then((res) => {
          if (res.success) {
            if (res.result.length > 0) {
              this.turnbackTargets = res.result

              // 改善要望No.84
              // ①	差戻先のデフォルトは自分の直前の承認者になっているが、
              // 申請者にしてほしい（全てのWFに対して）
              // 何か申請に不備があった場合、申請者本人に修正させるのが通常であるため
              // ②	差戻先の名称が「申請」になっているが、これを「申請者」に変更してほしい
              if (this.turnbackTargets.length == 1) {
                this.turnbackTaskDefinitionKey = this.turnbackTargets[this.turnbackTargets.length - 1].taskDefinitionKey
              }
              //this.turnbackTargets[0].name = this.turnbackTargets[0].name
            }
          }
        })
      }
    },

    //------------------------------------------------------ 下面为工作流事件 -----------------------------------------------------
    /*******************************************
     * 给子组件同步数据
     *******************************************/
    asyncFormData(form) {
      form.loginUserId = this.loginUser.id
      form.applicantInfo = this.applicantInfo
      form.deploymentId = this.deploymentId
      form.procInstId = this.procInstId
      form.executionId = this.executionId
      form.taskId = this.taskId
      form.comment = this.comment
    },

    /*******************************************
     * 向后台提交临时保存或申请数据
     *******************************************/
    excuteSaveOrApply(url, form, isSave) {
      var that = this

      this.asyncFormData(form)
      form.isSave = isSave

      if (isSave) {
        if (that.$refs.applyComponent.loading) {
          return
        } else {
          that.$refs.applyComponent.loading = true
        }

        postAction(url, form)
          .then((res) => {
            if (res.success) {
              // 关闭loading
              that.$refs.applyComponent.loading = false
              // 显示保存成功信息
              that.$message.success('临时保存成功')
              // 关闭窗口
              that.handleCancel()
            }
          })
          .catch(() => {
            // 关闭loading
            that.$refs.applyComponent.loading = false
          })
      } else {
        that.$confirm({
          title: that.$t('disp.warn'),
          content: that.$t('msg.flow.confirm.apply'),
          centered: true,
          onOk() {
            if (that.$refs.applyComponent.loading) {
              return
            } else {
              that.$refs.applyComponent.loading = true
            }

            postAction(url, form)
              .then((res) => {
                if (res.success) {
                  // 申请成功 继续验证是否可以自动审批
                  that.doAutoConfirm('申请成功', res.message)
                }
              })
              .catch(() => {
                // 关闭loading
                that.$refs.applyComponent.loading = false
              })
          },
          onCancel() {},
        })
      }
    },
    /*******************************************
     * 向后台提交批准数据(仅在有自定义批准处理时执行)
     *******************************************/
    excuteConfirm(url, form) {
      var that = this
      that.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.flow.confirm.approve'),
        centered: true,
        onOk() {
          if (that.$refs.applyComponent.loading) {
            return
          } else {
            that.$refs.applyComponent.loading = true
          }

          that.doConfirmPost(false, null, url, form)
        },
        onCancel() {},
      })
    },

    /*******************************************
     * 临时保存
     *******************************************/
    doSave() {
      if (this.taskId) {
        // 排他检查
        getAction(this.url.taskCheck, { taskId: this.taskId }).then((res) => {
          if (res.success) {
            this.$refs.applyComponent.handleSave()
          }
        })
      } else {
        this.$refs.applyComponent.handleSave()
      }
    },

    /*******************************************
     * 申请
     *******************************************/
    doApply() {
      if (this.taskId) {
        // 排他检查
        getAction(this.url.taskCheck, { taskId: this.taskId }).then((res) => {
          if (res.success) {
            this.$refs.applyComponent.handleApply()
          }
        })
      } else {
        this.$refs.applyComponent.handleApply()
      }
    },

    /*******************************************
     * 批准
     *******************************************/
    doConfirm() {
      var that = this

      // 自定义批准处理
      if (that.$refs.applyComponent.handleConfirm) {
        that.$refs.applyComponent.handleConfirm()
      }
      // 默认的批准处理
      else {
        that.$confirm({
          title: that.$t('disp.warn'),
          content: that.$t('msg.flow.confirm.approve'),
          centered: true,
          onOk() {
            if (that.$refs.applyComponent.loading) {
              return
            } else {
              that.$refs.applyComponent.loading = true
            }

            that.doConfirmPost()
          },
          onCancel() {},
        })
      }
    },
    // 向服务器发送批准请求
    doConfirmPost(autoConfirm, message, url, form) {
      var comment = autoConfirm ? null : this.comment

      if (!form) {
        form = {}
      }
      this.asyncFormData(form)
      form.autoConfirm = autoConfirm

      postAction(url || this.url.confirm, form)
        .then((res) => {
          // 承認成功の場合
          if (res.success) {
            if (!message) {
              message = this.$t(res.message)
            }
            this.doAutoConfirm(message)
          }
        })
        .finally(() => {})
    },
    // 自動批准
    doAutoConfirm(message, procInstId) {
      // procInstIdはメッセージが設定されている場合
      if (procInstId && isNaN(Number(procInstId))) {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: this.$t(procInstId),
        })
        // 关闭loading
        this.$refs.applyComponent.loading = false
        return
      }

      this.$refs.applyComponent.loading = true

      if (procInstId) {
        this.procInstId = procInstId
      }

      var approveFlag = this.loginUser.approveFlag
      // 自動承認できるタスクがない場合
      // 或は自動承認フラグは「しない」場合
      // 不做自动承认
      if (!this.procInstId || (approveFlag && approveFlag == '0')) {
        this.$refs.applyComponent.loading = false
        this.$message.success(message)
        this.handleCancel()
        return
      }

      // 引き続き、自動承認できるタスクを取得する
      postAction(this.url.getAutoConfirmTask, {
        procInstId: this.procInstId,
      })
        .then((res) => {
          if (res.result) {
            // 自動承認できるタスクがある場合
            this.taskId = res.result.id
            this.executionId = res.result.executionId
            this.doConfirmPost(true, message)
          } else {
            // 自動承認できるタスクがない場合
            this.$refs.applyComponent.loading = false
            this.$message.success(message)
            this.handleCancel()
          }
        })
        .catch(() => {
          // 关闭loading
          this.$refs.applyComponent.loading = false
        })
    },

    /*******************************************
     * 否决
     *******************************************/
    doRefuse() {
      // 否决的时候需要填写否决原因
      if (!this.comment && !window._CONFIG['isDebug']) {
        return this.$message.warning(this.$t('msg.flow.refuse.commentmsg'))
      }

      var that = this
      that.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.flow.confirm.refuse'),
        centered: true,
        onOk() {
          if (that.$refs.applyComponent.loading) {
            return
          } else {
            that.$refs.applyComponent.loading = true
          }

          postAction(that.url.refuse, { id: that.taskId, comment: that.comment })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.handleCancel()
              }
            })
            .finally(() => {
              that.$refs.applyComponent.loading = false
            })
        },
        onCancel() {},
      })
    },

    /*******************************************
     * 委派
     *******************************************/
    handleAppoint() {
      this.$refs.AppointModal.handleOpen({
        processInstanceId: this.applicantInfo.procInstId,
        endDateTimestamp: this.applicantInfo.endDate,
      })
    },

    /*******************************************
     * 驳回
     *******************************************/
    handleTurnbackOk() {
      // 驳回的时候需要选择驳回节点
      if (!this.turnbackTaskDefinitionKey) {
        return this.$message.warning('请选择驳回节点')
      }

      // 驳回的时候需要填写驳回原因
      if (!this.turnbackComment) {
        return this.$message.warning('请填写驳回原因、修改意见等')
      }

      var that = this
      that.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.flow.confirm.turnback'),
        centered: true,
        onOk() {
          that.visibleTurnback = false

          if (that.$refs.applyComponent.loading) {
            return
          } else {
            that.$refs.applyComponent.loading = true
          }

          // 驳回节点对象
          var turnbackTarget = XEUtils.first(
            XEUtils.filter(that.turnbackTargets, (r) => r.taskDefinitionKey == that.turnbackTaskDefinitionKey)
          )

          postAction(that.url.turnback, {
            taskId: that.taskId,
            comment: that.turnbackComment,
            targetTaskDefinitionKey: turnbackTarget.taskDefinitionKey,
            targetGatewayKey: turnbackTarget.gatewayKey,
          })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.handleCancel()
              }
            })
            .finally(() => {
              that.$refs.applyComponent.loading = false
            })
        },
        onCancel() {},
      })
    },
    doTurnback() {
      this.visibleTurnback = true
    },

    /*******************************************
     * 引用
     *******************************************/
    // 打开引用窗口
    openReuse() {
      this.$refs.ReuseModal.queryParam.modelId = this.modelId
      this.$refs.ReuseModal.queryParam.deploymentId = this.deploymentId
      this.$refs.ReuseModal.queryParam.processInstanceId = this.procInstId
      this.$refs.ReuseModal.visible = true
      this.$refs.ReuseModal.searchQuery()
    },
    // 引用
    doReuse(targetInstanceId) {
      this.$refs.applyComponent.handleReuse(targetInstanceId)
    },

    /*******************************************
     * 编辑确定
     *******************************************/
    doEdit() {
      this.$refs.applyComponent.handleEdit()
    },

    /*******************************************
     * 印刷账票
     *******************************************/
    doPublish() {
      this.$refs.applyComponent.handlePublish(this.taskId)
    },

    /*******************************************
     * 批量下载
     *******************************************/
    doBatchDownLoad() {
      this.$refs.applyComponent.handleBatchDownLoad(this.procInstId)
    },

    /*******************************************
     * 预览账票
     *******************************************/
    doPreview() {
      if (this.status == 'disp.flow.apply' || this.status == 'disp.flow.applyWait' || this.status == 'disp.flow.save') {
        this.$refs.applyComponent.handlePreview()
      } else {
        this.doPublish()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.div-apply {
  display: inline-block;

  .ant-btn {
    //min-width: 90px !important;
  }
}

.ant-empty-normal {
  margin: 0;

  /deep/ .ant-empty-description {
    margin-top: 0px;
  }
}

.div-apply-comment textarea.ant-input {
  margin-bottom: 0px;
  margin-top: 0px;
  // height: 74px;
  border-radius: 0;
}

.ant-btn.ant-btn-history {
  float: left;
  display: inline-block;
  margin-left: 0;
  border-color: var(--color-input-border);
  color: var(--color-font);
  box-shadow: none;

  &:hover {
    border-color: var(--color-primary-5);
  }
}

.comment-wrapper {
  position: relative;
  background: white;
  padding: 14px 0 0px;
  margin-top: 6px;

  /deep/ .ant-descriptions-title {
    margin-bottom: 0;
  }

  /deep/ .ant-descriptions-view {
    padding-top: 5px;
    background: white;
  }
}

.turnbackTarget {
  display: inline-block;
  background: #f8f8f8;
  padding: 4px 7px 3px 8px;
  font-size: 14px;
  margin-right: 6px;
  margin-bottom: 6px;
  border-radius: 1px;
  cursor: pointer;
  //min-width: 100px;
  text-align: center;
  transition: all 0.3s;
  min-width: 61px;
  position: relative;

  i {
    font-size: 12px;
    position: absolute;
    top: -4px;
    right: -4px;
    opacity: 0;
    transition: all 0.3s;
  }

  &.active {
    color: var(--color-primary-6);
    background: var(--color-primary-1);

    //.num {
    //  color: green !important;
    //}

    i {
      opacity: 1;
    }
  }

  &:hover {
    background: var(--color-primary-1);
  }
}

.track-wrapper {
  margin-top: 20px;
  height: calc(50vh - 93px);
  overflow: auto;
  background: rgba(255, 255, 255, 5%);
  border-radius: 0px;
  padding: 18px 16px 18px 20px;
  width: 350px;
  height: 241px;
  max-height: calc(100vh - 110px);
  background: white;
}

.track-wrapper.graph {
  background-image: linear-gradient(
      0deg,
      transparent 14px,
      rgba(204, 204, 204, 0.2) 14.5px,
      rgba(204, 204, 204, 0.2) 15px,
      transparent 15.1px,
      transparent 29px,
      rgba(204, 204, 204, 0.2) 29.5px,
      rgba(204, 204, 204, 0.2) 30px,
      transparent 30.1px,
      transparent 44px,
      rgba(204, 204, 204, 0.2) 44.5px,
      rgba(204, 204, 204, 0.2) 45px,
      transparent 45.1px,
      transparent 59px,
      rgba(204, 204, 204, 0.8) 60px
    ),
    linear-gradient(
      90deg,
      transparent 14px,
      rgba(204, 204, 204, 0.2) 14.5px,
      rgba(204, 204, 204, 0.2) 15px,
      transparent 15.1px,
      transparent 29px,
      rgba(204, 204, 204, 0.2) 29.5px,
      rgba(204, 204, 204, 0.2) 30px,
      transparent 30.1px,
      transparent 44px,
      rgba(204, 204, 204, 0.2) 44.5px,
      rgba(204, 204, 204, 0.2) 45px,
      transparent 45.1px,
      transparent 59px,
      rgba(204, 204, 204, 0.8) 60px
    );
  background-size: 60px 60px;
  width: 900px;
  padding: 0;
  background-position-y: -1px;
  border: 1px solid var(--color-tb-border);
}
</style>

